import CharmSuggestionsItem from 'owa-calendar-charm-suggestions-store/lib/schema/CharmSuggestionsItem';
import CharmSuggestionsStore from '../schema/CharmSuggestionsStore';
import store from '../store';
import { action } from 'satcheljs/lib/legacy';

export interface SetCharmSuggestions {
    store: CharmSuggestionsStore;
}

/**
 * Updates the value of the charm suggestions
 */
export default action('setCharmSuggestions')(function setCharmSuggestions(
    suggestions: CharmSuggestionsItem[],
    state: SetCharmSuggestions = { store: store }
) {
    state.store.suggestions = suggestions;
});
